module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breeding-rhombus-spinner",
    style: (_vm.spinnerStyle)
  }, [_vm._l((_vm.rhombusesStyles), function(rs, index) {
    return _c('div', {
      key: index,
      staticClass: "rhombus",
      class: ("child-" + (index + 1)),
      style: (rs)
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "rhombus big",
    style: (_vm.bigRhombusStyle)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89e459a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/BreedingRhombusSpinner.vue
// module id = 279
// module chunks = 1